import React from 'react';
import moment from 'moment'; 

import {
	Col
} from '@sketchpixy/rubix';
import { HTTP } from 'meteor/http';

import { PlanningPeriod } from './PlanningPeriod';
import { Weather } from '../../external_api/weather';

export const PlanningDay = ({date, place}) =>
<div>
	<Col sm={12}>
		<center>
			<p>
				{moment(date).format('dddd D MMMM')}
				&nbsp;
				<Weather date={moment(date).format('YYYY-MM-DD')}></Weather>
			</p>
		</center>
	</Col>
	<Col sm={6}>
		<PlanningPeriod date={date} place={place} period="morning" />	
	</Col>
	<Col sm={6}>
		<PlanningPeriod date={date} place={place} period="evening" />	
	</Col>
</div>;




/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningDay.js
 **/